import React, { useMemo } from 'react';

import { IPositionWithCandidates } from '@types';
import { formatSkillLabel } from '@utils';
import { ISuggestion, SuggestionSearch } from './SuggestionSearch';

const SUGGESTION_KINDS = ['Candidates', 'Positions', 'Tech stack', 'Location'];

const collectSources = (positions: IPositionWithCandidates[]): ISuggestion[] =>
  positions.flatMap((position) => [
    { kind: 'Positions', value: position.name },
    ...position.candidates.flatMap((candidate) => [
      {
        kind: 'Candidates',
        value: `${candidate.firstName} ${candidate.lastName}`,
      },
      { kind: 'Location', value: candidate.country },
      ...(candidate.skills ?? []).map((skill) => ({
        kind: 'Tech stack',
        value: formatSkillLabel(skill),
      })),
    ]),
  ]);

interface ICandidateSearchProps {
  data: IPositionWithCandidates[];
  value: string;
  fullWidth?: boolean;
  onChange: (value: string) => void;
}

export const CandidateSearch: React.FC<ICandidateSearchProps> = ({
  data,
  value,
  fullWidth,
  onChange,
}) => {
  const sources = useMemo(() => collectSources(data), [data]);

  return (
    <SuggestionSearch
      sources={sources}
      kinds={SUGGESTION_KINDS}
      placeholder="Search candidates, positions, stack, location"
      value={value}
      fullWidth={fullWidth}
      onChange={onChange}
    />
  );
};
